import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router } from "react-router-dom";
import Secured from "./components/secured";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import Store from "./redux/store";
import GlobalOverrides from "./globalOverrides";

const history = createBrowserHistory({ basename: "/aplicacao/sistec" });

ReactDOM.render(
  <>
    <GlobalOverrides />

    <Provider store={Store}>
      <Router history={history}>
        <Secured {...history} />
      </Router>
    </Provider>
  </>,
  document.getElementById("root")
);

serviceWorker.unregister();
export default history;
